export default "/wp-content/themes/onnit/script/cart/dist/newMoodUpsellBg-e0b2f851.jpg";